module.exports = __webpack_public_path__ + "img/1489428925.b4a0bee8.jpg";